import React from 'react'

import { Details, Row, Block } from '../../components/details/details'
import { Tab, TabPanel, TabList, Tabs } from 'react-tabs'

import AreaWorkTrackersContainer from '../../containers/work-trackers/area-work-trackers-container'
import AreaActivityContainer from '../../containers/area-activities/area-activity-container'

export default ({
  area = {},
  latestHistory = {},
  technician = {}
}) => (
  <div>
    <Details>
      <Row>
        <Block title='room'><p>{area.name}</p></Block>
        <Block title='last cleaned'><p>{formatLastCleaning(latestHistory)}</p></Block>
        <Block title='last technician'><p>{technician.name || '—'}</p></Block>
      </Row>
      <Row>
        <Block title='last services'>
          {formatLastServices(latestHistory)}
        </Block>
      </Row>
    </Details>

    <Tabs>
      <TabList>
        <Tab>Summary</Tab>
        <Tab>History</Tab>
      </TabList>

      <TabPanel className='list'>
        <AreaWorkTrackersContainer areaId={area.id} />
      </TabPanel>

      <TabPanel className='list'>
        <AreaActivityContainer areaId={area.id} />
      </TabPanel>
    </Tabs>
  </div>
)

function formatLastCleaning (latestHistory) {
  if (latestHistory.completedAt) {
    return latestHistory.completedAt.format('MMMM Do, YYYY, h:mm A')
  } else {
    return '—'
  }
}

function formatLastServices (latestHistory) {
  const services = latestHistory.services || []

  if (services.length === 0) {
    return <p className='no-content'>None.</p>
  }

  return (
    <ul>
      {services.map(service =>
        <li key={service}>{service}</li>
      )}
    </ul>
  )
}



// WEBPACK FOOTER //
// ./src/components/areas/work-tracker-area-details.js